import Vue from "vue";
import VueGtm from "vue-gtm";
import router from "./router";

Vue.use(VueGtm, {
	enabled: process.env.NODE_ENV === "production",
	debug: process.env.NODE_ENV === "development",
	vueRouter: router,
	id: "GTM-NHZJFNL"
});
